module.exports = __webpack_public_path__ + "static/img/hb_3-min.add8cf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_3-min.png
// module id = 3GjT
// module chunks = 1